/**
 * Miniatúra dosky do výberu mapy. Kreslí sa priamo z dát mapy (SVG), takže
 * nová mapa nepotrebuje žiadny obrázok — a náhľad nikdy nezostane zastaraný.
 */

import type { GameMap } from '@unmatched/engine';

interface Props {
  map: GameMap;
  width?: number;
}

export function MapThumb({ map, width = 210 }: Props) {
  const scale = width / map.w;
  const height = Math.round(map.h * scale);
  const zoneColor = new Map(map.zones.map((zone) => [zone.id, zone.color]));

  return (
    <svg
      className="mapThumb"
      viewBox={`0 0 ${map.w} ${map.h}`}
      width={width}
      height={height}
      role="img"
      aria-label={`Náhľad mapy ${map.name}`}
    >
      {map.edges.map(([a, b]) => {
        const from = map.spaces.find((s) => s.id === a);
        const to = map.spaces.find((s) => s.id === b);
        if (!from || !to) return null;
        return (
          <line
            key={`${a}-${b}`}
            x1={from.x}
            y1={from.y}
            x2={to.x}
            y2={to.y}
            stroke="#39435a"
            strokeWidth={10}
          />
        );
      })}

      {map.spaces.map((space) => {
        const primary = zoneColor.get(space.zones[0] ?? '') ?? '#3d4859';
        const second = space.zones[1] ? zoneColor.get(space.zones[1]) : undefined;
        return (
          <g key={space.id}>
            <circle
              cx={space.x}
              cy={space.y}
              r={space.r}
              fill={primary}
              fillOpacity={0.35}
              stroke={primary}
              strokeWidth={8}
            />
            {/* Priestor v dvoch zónach dostane druhý prstenec — ako na doske. */}
            {second ? (
              <circle
                cx={space.x}
                cy={space.y}
                r={space.r - 16}
                fill="none"
                stroke={second}
                strokeWidth={8}
              />
            ) : null}
            {space.start !== undefined ? (
              <circle cx={space.x} cy={space.y} r={space.r * 0.38} fill="#f0f3fa" />
            ) : null}
          </g>
        );
      })}
    </svg>
  );
}
